// Menu Data with Turkish and English translations
// Allergen Icons: gluten, dairy, nuts, shellfish, eggs, soy, fish, celery, mustard, sesame, sulphites, lupin, molluscs, peanuts

export const allergenInfo = {
  gluten: { tr: 'Gluten', en: 'Gluten', icon: '🌾' },
  dairy: { tr: 'Süt Ürünleri', en: 'Dairy', icon: '🥛' },
  nuts: { tr: 'Kuruyemiş', en: 'Nuts', icon: '🥜' },
  shellfish: { tr: 'Kabuklu Deniz', en: 'Shellfish', icon: '🦐' },
  eggs: { tr: 'Yumurta', en: 'Eggs', icon: '🥚' },
  soy: { tr: 'Soya', en: 'Soy', icon: '🫘' },
  fish: { tr: 'Balık', en: 'Fish', icon: '🐟' },
  celery: { tr: 'Kereviz', en: 'Celery', icon: '🥬' },
  mustard: { tr: 'Hardal', en: 'Mustard', icon: '🟡' },
  sesame: { tr: 'Susam', en: 'Sesame', icon: '⚪' },
  spicy: { tr: 'Acılı', en: 'Spicy', icon: '🌶️' },
};

export const categories = [
  {
    id: 'baslangiclar',
    name: { tr: 'Başlangıçlar', en: 'Starters' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Lezzetli başlangıçlar', en: 'Delicious starters' },
  },
  {
    id: 'salatalar',
    name: { tr: 'Meze & Salatalar', en: 'Meze & Salads' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Geleneksel mezeler ve taze salatalar', en: 'Traditional meze and fresh salads' },
  },
  {
    id: 'durumler',
    name: { tr: 'Dürümler', en: 'Wraps' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Lavaşta sarılı lezzetler', en: 'Delicious wraps in lavash bread' },
  },
  {
    id: 'adana-kebap',
    name: { tr: 'Adana Kebap', en: 'Adana Kebab' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Özgün Adana lezzetleri', en: 'Authentic Adana flavors' },
  },
  {
    id: 'gomsu-et',
    name: { tr: 'Gomşu Et', en: 'Gomsu Meat' },
    image: '/images/menu/cat-gomsu-et.webp',
    description: { tr: 'Özel et yemekleri', en: 'Special meat dishes' },
  },
  {
    id: 'gomsu-tavuk',
    name: { tr: 'Gomşu Tavuk', en: 'Gomsu Chicken' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Izgara tavuk çeşitleri', en: 'Grilled chicken varieties' },
  },
  {
    id: 'gomsu-spesiyal',
    name: { tr: 'Gomşu Spesiyal', en: 'Gomsu Special' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Şefin özel seçimleri', en: "Chef's special selections" },
  },
  {
    id: 'pideler',
    name: { tr: 'Pideler', en: 'Pide' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Geleneksel Türk pidesi', en: 'Traditional Turkish flatbread' },
  },
  {
    id: 'fit-menuler',
    name: { tr: 'Fit Menüler', en: 'Fit Menus' },
    image: '/images/menu/cat-fit-menuler.webp',
    description: { tr: 'Sağlıklı ve hafif seçenekler', en: 'Healthy and light options' },
  },
  {
    id: 'tatlilar',
    name: { tr: 'Tatlılar', en: 'Desserts' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Geleneksel Türk tatlıları', en: 'Traditional Turkish desserts' },
  },
  {
    id: 'icecekler',
    name: { tr: 'İçecekler', en: 'Beverages' },
    image: '/images/menu/cat-icecekler.webp',
    description: { tr: 'Soğuk ve sıcak içecekler', en: 'Cold and hot beverages' },
  },
  {
    id: 'alkollu-icecekler',
    name: { tr: 'Alkollü İçecekler', en: 'Alcoholic Beverages' },
    image: '/images/menu/placeholder.webp',
    description: { tr: 'Seçkin şarap ve içkiler', en: 'Fine wines and spirits' },
  },
];

export const menuItems = {
  baslangiclar: [
    {
      id: 1,
      name: { tr: 'Çorba', en: 'Soup' },
      description: { tr: 'Günün çorbası, sıcak servis edilir', en: 'Soup of the day, served hot' },
      price: 240,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isPopular: true,
    },
    {
      id: 2,
      name: { tr: 'Çiğ Köfte', en: 'Raw Kofta' },
      description: { tr: 'Geleneksel çiğ köfte, nar ekşisi ve yeşillik ile', en: 'Traditional raw kofta with pomegranate syrup and greens' },
      price: 390,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 5,
      name: { tr: 'Patates Cipsi', en: 'Potato Chips' },
      description: { tr: 'Çıtır patates cipsi, özel baharatlar ile', en: 'Crispy potato chips with special spices' },
      price: 260,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 6,
      name: { tr: 'İçli Köfte', en: 'Stuffed Kofta' },
      description: { tr: 'Geleneksel içli köfte, kıymalı iç harç ile', en: 'Traditional stuffed kofta with minced meat filling' },
      price: 215,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 3,
      name: { tr: 'Fındık Lahmacun (6 Adet)', en: 'Mini Lahmacun (6 Pcs)' },
      description: { tr: 'Mini boy lahmacun, kıymalı, baharatlı', en: 'Mini lahmacun with minced meat and spices' },
      price: 415,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
    },
    {
      id: 4,
      name: { tr: 'Peynirli Fındık (6 Adet)', en: 'Cheesy Mini Pita (6 Pcs)' },
      description: { tr: 'Mini boy peynirli pide', en: 'Mini cheese pita' },
      price: 415,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
    },
  ],
  salatalar: [
    {
      id: 10,
      name: { tr: 'Humus', en: 'Hummus' },
      description: { tr: 'Nohut püresi, tahin, zeytinyağı', en: 'Chickpea puree, tahini, olive oil' },
      price: 205,
      image: '/images/menu/placeholder.webp',
      allergens: ['sesame'],
      isPopular: true,
    },
    {
      id: 11,
      name: { tr: 'Babagannuş', en: 'Baba Ghanoush' },
      description: { tr: 'Közlenmiş patlıcan, tahin, sarımsak', en: 'Roasted eggplant, tahini, garlic' },
      price: 220,
      image: '/images/menu/placeholder.webp',
      allergens: ['sesame'],
    },
    {
      id: 12,
      name: { tr: 'Acılı Ezme', en: 'Spicy Ezme' },
      description: { tr: 'Domates, biber, soğan ezme', en: 'Tomato, pepper, onion paste' },
      price: 220,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
      isSpicy: true,
    },
    {
      id: 130,
      name: { tr: 'Cacık', en: 'Cacik' },
      description: { tr: 'Yoğurt, salatalık, sarımsak, nane', en: 'Yogurt, cucumber, garlic, mint' },
      price: 205,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
      isPopular: true,
    },
    {
      id: 131,
      name: { tr: 'Kornişonlu Yoğurt', en: 'Yogurt with Pickles' },
      description: { tr: 'Süzme yoğurt, kornişon turşu', en: 'Strained yogurt with pickles' },
      price: 195,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
    },
    {
      id: 132,
      name: { tr: 'Köz Soğan', en: 'Grilled Onion' },
      description: { tr: 'Közlenmiş soğan', en: 'Grilled onion' },
      price: 180,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 133,
      name: { tr: 'Yoğurt', en: 'Yogurt' },
      description: { tr: 'Taze süzme yoğurt', en: 'Fresh strained yogurt' },
      price: 195,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
    },
    {
      id: 134,
      name: { tr: 'Mütebbel', en: 'Mutabbal' },
      description: { tr: 'Közlenmiş patlıcan, yoğurt, sarımsak', en: 'Roasted eggplant, yogurt, garlic' },
      price: 215,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
    },
    {
      id: 135,
      name: { tr: 'Tablacı Soğan', en: 'Tablaci Onion' },
      description: { tr: 'Özel baharatlı soğan salatası', en: 'Special spiced onion salad' },
      price: 270,
      image: '/images/menu/tablaci-sogan.webp',
      allergens: [],
    },
    {
      id: 136,
      name: { tr: 'Soğan Salatası', en: 'Onion Salad' },
      description: { tr: 'Taze soğan salatası, sumak ile', en: 'Fresh onion salad with sumac' },
      price: 180,
      image: '/images/menu/tablaci-sogan.webp',
      allergens: [],
    },
    {
      id: 137,
      name: { tr: 'Kaşık Salatası', en: 'Spoon Salad' },
      description: { tr: 'İnce doğranmış sebze salatası', en: 'Finely chopped vegetable salad' },
      price: 420,
      image: '/images/menu/cat-fit-menuler.webp',
      allergens: [],
      isPopular: true,
    },
    {
      id: 14,
      name: { tr: 'Çoban Salata', en: 'Shepherd Salad' },
      description: { tr: 'Domates, salatalık, biber, soğan', en: 'Tomato, cucumber, pepper, onion' },
      price: 420,
      image: '/images/menu/coban-salata.webp',
      allergens: [],
      isVegan: true,
    },
    {
      id: 15,
      name: { tr: 'Gavurdağı Salatası', en: 'Gavurdağı Salad' },
      description: { tr: 'Cevizli, narlı özel salata', en: 'Special salad with walnuts and pomegranate' },
      price: 480,
      image: '/images/menu/cat-fit-menuler.webp',
      allergens: ['nuts'],
      isPopular: true,
    },
    {
      id: 17,
      name: { tr: 'Mevsim Salata', en: 'Seasonal Salad' },
      description: { tr: 'Mevsim yeşillikleri, limon sos', en: 'Seasonal greens, lemon dressing' },
      price: 360,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isVegan: true,
    },
  ],
  durumler: [
    {
      id: 15,
      name: { tr: 'Adana Dürüm', en: 'Adana Wrap' },
      description: { tr: 'Acılı Adana kebap, lavaş, soğan', en: 'Spicy Adana kebab, lavash, onion' },
      price: 495,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'spicy'],
      isPopular: true,
    },
    {
      id: 60,
      name: { tr: 'Tavuk Adana Dürüm', en: 'Chicken Adana Wrap' },
      description: { tr: 'Tavuk Adana kebap, lavaş, soğan, yeşillik', en: 'Chicken Adana kebab, lavash, onion, greens' },
      price: 495,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 61,
      name: { tr: 'Tavuk Şiş Dürüm', en: 'Chicken Shish Wrap' },
      description: { tr: 'Tavuk şiş, lavaş, soğan, yeşillik', en: 'Chicken shish, lavash, onion, greens' },
      price: 495,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
    },
    {
      id: 62,
      name: { tr: 'Et Şiş Dürüm', en: 'Beef Shish Wrap' },
      description: { tr: 'Dana et şiş, lavaş, soğan, yeşillik', en: 'Beef shish, lavash, onion, greens' },
      price: 540,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 64,
      name: { tr: 'Ciğer Şiş Dürüm', en: 'Liver Shish Wrap' },
      description: { tr: 'Ciğer şiş, lavaş, soğan, yeşillik', en: 'Liver shish, lavash, onion, greens' },
      price: 495,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
    },
    {
      id: 63,
      name: { tr: 'Gurme Dürüm', en: 'Gourmet Wrap' },
      description: { tr: 'Özel gurme dürüm, lavaş, közlenmiş sebzeler', en: 'Special gourmet wrap with grilled vegetables' },
      price: 715,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isSignature: true,
    },
  ],
  'adana-kebap': [
    {
      id: 70,
      name: { tr: 'Adana Kebap (120 Gr)', en: 'Adana Kebab (120g)' },
      description: { tr: 'El yapımı acılı Adana kebap, pilav, salata ile servis edilir', en: 'Handmade spicy Adana kebab, served with rice and salad' },
      price: 845,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
      isPopular: true,
    },
    {
      id: 71,
      name: { tr: 'Adana Kebap (180 Gr)', en: 'Adana Kebab (180g)' },
      description: { tr: 'El yapımı acılı Adana kebap, pilav, salata ile servis edilir', en: 'Handmade spicy Adana kebab, served with rice and salad' },
      price: 1265,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
    },
    {
      id: 72,
      name: { tr: 'Adana Kebap (240 Gr)', en: 'Adana Kebab (240g)' },
      description: { tr: 'El yapımı acılı Adana kebap, pilav, salata ile servis edilir', en: 'Handmade spicy Adana kebab, served with rice and salad' },
      price: 1690,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
      isPopular: true,
    },
    {
      id: 73,
      name: { tr: 'Adana Kebap (380 Gr)', en: 'Adana Kebab (380g)' },
      description: { tr: 'El yapımı acılı Adana kebap, pilav, salata ile servis edilir', en: 'Handmade spicy Adana kebab, served with rice and salad' },
      price: 2535,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
    },
    {
      id: 74,
      name: { tr: 'Adana Kebap (480 Gr)', en: 'Adana Kebab (480g)' },
      description: { tr: 'El yapımı acılı Adana kebap, pilav, salata ile servis edilir', en: 'Handmade spicy Adana kebab, served with rice and salad' },
      price: 3380,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
    },
    {
      id: 75,
      name: { tr: 'Adana Kebap (1/2 Mt.)', en: 'Adana Kebab (Half Meter)' },
      description: { tr: 'Yarım metre Adana kebap, özel servis tabağı ile', en: 'Half meter Adana kebab with special serving platter' },
      price: 4225,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
      isSignature: true,
    },
    {
      id: 76,
      name: { tr: 'Adana Kebap (1 Mt.)', en: 'Adana Kebab (One Meter)' },
      description: { tr: 'Bir metre Adana kebap, özel servis tabağı ile', en: 'One meter Adana kebab with special serving platter' },
      price: 8450,
      image: '/images/menu/placeholder.webp',
      allergens: ['spicy'],
      isSignature: true,
      isPopular: true,
    },
  ],
  'gomsu-et': [
    {
      id: 90,
      name: { tr: 'Ciğer Şiş', en: 'Liver Shish' },
      description: { tr: 'Izgara dana ciğeri, soğan, maydanoz ile servis edilir', en: 'Grilled beef liver, served with onion and parsley' },
      price: 875,
      image: '/images/menu/placeholder.webp',
      video: 'https://customer-assets.emergentagent.com/job_0ccb0080-2c65-44ac-b139-d1534eef4e80/artifacts/gi0vmmfo_AQPM45lOt8nW2B_W2Bfo7swtccdJJVychtZPJpclCFbErO1cZrrnt40uWgjzLcrCVfWZ20FE2VpfQrdp81uNxkoDaL3yRJyof7L_gBwMGhsy6A.mp4',
      allergens: [],
      isPopular: true,
      hasVideo: true,
    },
    {
      id: 91,
      name: { tr: 'Yoğurtlu Kebap', en: 'Kebab with Yogurt' },
      description: { tr: 'Kebap, yoğurt, tereyağlı domates sosu ile', en: 'Kebab with yogurt and buttery tomato sauce' },
      price: 985,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
      isPopular: true,
    },
    {
      id: 92,
      name: { tr: 'Kuzu Kaburga', en: 'Lamb Ribs' },
      description: { tr: 'Fırında pişmiş kuzu kaburga, özel soslar ile', en: 'Oven-baked lamb ribs with special sauces' },
      price: 1095,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isSignature: true,
    },
    {
      id: 93,
      name: { tr: 'Çöp Şiş', en: 'Diced Meat Shish' },
      description: { tr: 'Marine edilmiş kuşbaşı et, közlenmiş sebzeler ile', en: 'Marinated diced meat with grilled vegetables' },
      price: 1080,
      image: '/images/menu/placeholder.webp',
      video: 'https://customer-assets.emergentagent.com/job_0ccb0080-2c65-44ac-b139-d1534eef4e80/artifacts/woku7azl_%C3%A7%C3%B6p%20%C5%9Fi%C5%9F.mp4',
      allergens: [],
      isPopular: true,
      hasVideo: true,
    },
    {
      id: 94,
      name: { tr: 'Patlıcan Kebabı', en: 'Eggplant Kebab' },
      description: { tr: 'Közlenmiş patlıcan üzerinde kebap, domates sos ile', en: 'Kebab on grilled eggplant with tomato sauce' },
      price: 1095,
      image: '/images/menu/placeholder.webp',
      video: 'https://customer-assets.emergentagent.com/job_7ee01bf9-b01f-4d24-a36d-b8b06bffdcd0/artifacts/7myzmwit_AQMBCZwU_BnzL-QW7bCugi1-xyNnzhzr1_uD32mKSrvUQcWmLlLNvKs_ajDk8kV8l4-vMW70iDBe-J6j05x3aQ76dVrscorQoKBxyU3a7_7YwA.mp4',
      allergens: [],
      hasVideo: true,
    },
    {
      id: 95,
      name: { tr: 'Sarma Beyti', en: 'Beyti Roll' },
      description: { tr: 'Lavaşta sarılı kebap, yoğurt, tereyağlı sos ile', en: 'Kebab wrapped in lavash with yogurt and butter sauce' },
      price: 985,
      image: '/images/menu/placeholder.webp',
      video: 'https://customer-assets.emergentagent.com/job_0ccb0080-2c65-44ac-b139-d1534eef4e80/artifacts/s8npzkud_sarma%20beyti.mp4',
      allergens: ['gluten', 'dairy'],
      isPopular: true,
      hasVideo: true,
    },
    {
      id: 96,
      name: { tr: 'Ali Nazik Kebabı', en: 'Ali Nazik Kebab' },
      description: { tr: 'Közlenmiş patlıcan püresi üzerinde kebap, yoğurt ile', en: 'Kebab on smoky eggplant puree with yogurt' },
      price: 1395,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
      isSignature: true,
    },
    {
      id: 97,
      name: { tr: 'Pirzola', en: 'Lamb Chops' },
      description: { tr: 'Izgara kuzu pirzola, özel baharatlar ile', en: 'Grilled lamb chops with special spices' },
      price: 1395,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isPopular: true,
    },
    {
      id: 98,
      name: { tr: 'Kuzu Bonfile Şiş', en: 'Lamb Tenderloin Shish' },
      description: { tr: 'Kuzu bonfile şiş, közlenmiş sebzeler ile servis edilir', en: 'Lamb tenderloin shish served with grilled vegetables' },
      price: 1425,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isSignature: true,
    },
    {
      id: 50,
      name: { tr: 'Güveç (Et)', en: 'Clay Pot (Meat)' },
      description: { tr: 'Dana eti, sebzeler, özel baharat', en: 'Beef meat, vegetables, special spices' },
      price: 1485,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 140,
      name: { tr: 'Saç Kavurma (Et)', en: 'Pan Fried Meat' },
      description: { tr: 'Saç kavurma dana eti, sebzeler ile', en: 'Pan fried beef with vegetables' },
      price: 1425,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isPopular: true,
    },
    {
      id: 141,
      name: { tr: 'Saç Kavurma (Ciğer)', en: 'Pan Fried Liver' },
      description: { tr: 'Saç kavurma ciğer, sebzeler ile', en: 'Pan fried liver with vegetables' },
      price: 1370,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
  ],
  'gomsu-tavuk': [
    {
      id: 28,
      name: { tr: 'Tavuk Kanat', en: 'Chicken Wings' },
      description: { tr: 'Baharatlı tavuk kanat (8 adet)', en: 'Spiced chicken wings (8 pcs)' },
      price: 950,
      image: '/images/menu/placeholder.webp',
      video: 'https://customer-assets.emergentagent.com/job_0ccb0080-2c65-44ac-b139-d1534eef4e80/artifacts/dkhqa147_kanat.mp4',
      allergens: ['spicy'],
      isPopular: true,
      hasVideo: true,
    },
    {
      id: 100,
      name: { tr: 'Tavuk Adana (120 Gr.)', en: 'Chicken Adana (120g)' },
      description: { tr: 'Tavuk Adana kebap, pilav, salata ile servis edilir', en: 'Chicken Adana kebab, served with rice and salad' },
      price: 840,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 51,
      name: { tr: 'Tavuk İncik Çöp', en: 'Chicken Drumstick Shish' },
      description: { tr: 'Izgara tavuk incik, özel baharatlar ile', en: 'Grilled chicken drumstick with special spices' },
      price: 945,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isPopular: true,
    },
    {
      id: 101,
      name: { tr: 'Tavuk Çöp Şiş', en: 'Chicken Diced Shish' },
      description: { tr: 'Marine edilmiş tavuk çöp şiş, közlenmiş sebzeler ile', en: 'Marinated chicken diced shish with grilled vegetables' },
      price: 840,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 102,
      name: { tr: 'Kemikli Tavuk', en: 'Bone-in Chicken' },
      description: { tr: 'Izgara kemikli tavuk, özel baharatlar ile', en: 'Grilled bone-in chicken with special spices' },
      price: 940,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 29,
      name: { tr: 'Tavuk Pirzola', en: 'Chicken Chops' },
      description: { tr: 'Izgara tavuk but, salata, patates', en: 'Grilled chicken thigh, salad, potatoes' },
      price: 985,
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 52,
      name: { tr: 'Güveç (Tavuk)', en: 'Clay Pot (Chicken)' },
      description: { tr: 'Tavuk göğsü, mantar, krema', en: 'Chicken breast, mushroom, cream' },
      price: 1415,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
    },
  ],
  'gomsu-spesiyal': [
    {
      id: 31,
      name: { tr: 'GOMŞU FULL', en: 'Gomsu Full' },
      description: { tr: 'Zengin karışık kebap tabağı, özel pide, közlenmiş domates ve biber, mevsim salatası, yeşillik ile servis edilir', en: 'Rich mixed kebab platter served with special pita, grilled tomato and pepper, seasonal salad, greens' },
      price: 2595,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isSignature: true,
      isPopular: true,
    },
    {
      id: 32,
      name: { tr: 'GOMŞU ET', en: 'Gomsu Meat' },
      description: { tr: 'Özel et kebap tabağı, pide, közlenmiş sebzeler, mevsim salatası ile servis edilir', en: 'Special meat kebab platter served with pita, grilled vegetables, seasonal salad' },
      price: 1525,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isSignature: true,
    },
    {
      id: 33,
      name: { tr: 'GOMŞU TAVUK', en: 'Gomsu Chicken' },
      description: { tr: 'Özel tavuk kebap tabağı, pide, közlenmiş sebzeler, mevsim salatası ile servis edilir', en: 'Special chicken kebab platter served with pita, grilled vegetables, seasonal salad' },
      price: 1370,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 34,
      name: { tr: 'İKİYÜZLÜ KEBAP', en: '2Faces Kebab' },
      description: { tr: 'Özel iki yüzlü kebap, pide, közlenmiş domates ve biber, mevsim salatası ile servis edilir', en: 'Special two-faced kebab served with pita, grilled tomato and pepper, seasonal salad' },
      price: 1535,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'spicy'],
      isSignature: true,
    },
    {
      id: 35,
      name: { tr: 'SOSYETE BEYTİSİ', en: 'High Society Beyti' },
      description: { tr: 'Özel sosyete beyti, yoğurt, tereyağlı domates sosu ile servis edilir', en: 'Special high society beyti served with yogurt, buttery tomato sauce' },
      price: 1535,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
      isSignature: true,
      isPopular: true,
    },
    {
      id: 36,
      name: { tr: 'FISTIKLI ADANA', en: 'Adana with Pistachio' },
      description: { tr: 'Antep fıstıklı özel Adana kebap, pide, közlenmiş sebzeler ile servis edilir', en: 'Special Adana kebab with pistachio, served with pita, grilled vegetables' },
      price: 1370,
      image: '/images/menu/placeholder.webp',
      video: 'https://customer-assets.emergentagent.com/job_0ccb0080-2c65-44ac-b139-d1534eef4e80/artifacts/4omh3oww_f%C4%B1st%C4%B1k%20kebab%C4%B1.mp4',
      allergens: ['gluten', 'nuts', 'spicy'],
      isPopular: true,
      hasVideo: true,
    },
    {
      id: 37,
      name: { tr: 'GOMŞU XL (4 Kişilik)', en: 'Gomsu XL (For 4)' },
      description: { tr: 'Karışık kebap tabağı, 6 çeşit meze, salata, fındık lahmacun, peynirli fındık, çiğ köfte ve patates cipsi ile servis edilir', en: 'Mixed kebab platter with 6 types of appetizers, salad, findik lahmacun, cheesy findik, raw kofta and potato chips' },
      price: 7250,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy', 'nuts', 'spicy'],
      isSignature: true,
      forPeople: 4,
    },
    {
      id: 38,
      name: { tr: 'GOMŞU XXL (6 Kişilik)', en: 'Gomsu XXL (For 6)' },
      description: { tr: 'Büyük karışık kebap tabağı, 6 çeşit meze, salata, fındık lahmacun, peynirli fındık, çiğ köfte ve patates cipsi ile servis edilir', en: 'Large mixed kebab platter with 6 types of appetizers, salad, findik lahmacun, cheesy findik, raw kofta and potato chips' },
      price: 10200,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy', 'nuts', 'spicy'],
      isSignature: true,
      forPeople: 6,
    },
  ],
  pideler: [
    {
      id: 38,
      name: { tr: 'Lahmacun', en: 'Lahmacun' },
      description: { tr: 'İnce hamur, kıyma, yeşillik (1 adet)', en: 'Thin crust, minced meat, greens (1 pc)' },
      price: 175,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 150,
      name: { tr: 'Peynirli Pide', en: 'Cheese Pide' },
      description: { tr: 'Kaşar peyniri, tereyağı', en: 'Kashkaval cheese, butter' },
      price: 680,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
      isPopular: true,
      extras: [
        { tr: 'Peynir', en: 'Cheese' },
        { tr: 'Mantar', en: 'Mushroom' },
        { tr: 'Yumurta', en: 'Egg' },
        { tr: 'Acı Biber', en: 'Hot Pepper' },
      ],
    },
    {
      id: 151,
      name: { tr: 'Etli Pide', en: 'Meat Pide' },
      description: { tr: 'Dana kuşbaşı, biber, domates', en: 'Diced beef, pepper, tomato' },
      price: 760,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      extras: [
        { tr: 'Peynir', en: 'Cheese' },
        { tr: 'Mantar', en: 'Mushroom' },
        { tr: 'Yumurta', en: 'Egg' },
        { tr: 'Acı Biber', en: 'Hot Pepper' },
      ],
    },
    {
      id: 152,
      name: { tr: 'Kıymalı Pide', en: 'Minced Meat Pide' },
      description: { tr: 'Kıyma, soğan, domates', en: 'Minced meat, onion, tomato' },
      price: 695,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
      extras: [
        { tr: 'Peynir', en: 'Cheese' },
        { tr: 'Mantar', en: 'Mushroom' },
        { tr: 'Yumurta', en: 'Egg' },
        { tr: 'Acı Biber', en: 'Hot Pepper' },
      ],
    },
    {
      id: 154,
      name: { tr: 'Tavuklu Pide', en: 'Chicken Pide' },
      description: { tr: 'Tavuk parçaları, kaşar peyniri', en: 'Chicken pieces, kashkaval cheese' },
      price: 715,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
      extras: [
        { tr: 'Peynir', en: 'Cheese' },
        { tr: 'Mantar', en: 'Mushroom' },
        { tr: 'Yumurta', en: 'Egg' },
        { tr: 'Acı Biber', en: 'Hot Pepper' },
      ],
    },
    {
      id: 155,
      name: { tr: 'Karışık Pide', en: 'Mixed Pide' },
      description: { tr: 'Sucuk, kaşar, yumurta', en: 'Sausage, cheese, egg' },
      price: 765,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy', 'eggs'],
      extras: [
        { tr: 'Peynir', en: 'Cheese' },
        { tr: 'Mantar', en: 'Mushroom' },
        { tr: 'Yumurta', en: 'Egg' },
        { tr: 'Acı Biber', en: 'Hot Pepper' },
      ],
    },
    {
      id: 153,
      name: { tr: 'Kıbrıs Pastırmalı Pide', en: 'Cyprus Pastrami Pide' },
      description: { tr: 'Kıbrıs pastırması, kaşar peyniri', en: 'Cyprus pastrami, kashkaval cheese' },
      price: 765,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
      isPopular: true,
      extras: [
        { tr: 'Peynir', en: 'Cheese' },
        { tr: 'Mantar', en: 'Mushroom' },
        { tr: 'Yumurta', en: 'Egg' },
        { tr: 'Acı Biber', en: 'Hot Pepper' },
      ],
    },
    {
      id: 156,
      name: { tr: 'Vejetaryan Pide', en: 'Vegetarian Pide' },
      description: { tr: 'Karışık sebzeler, kaşar peyniri', en: 'Mixed vegetables, kashkaval cheese' },
      price: 780,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
      isVegan: false,
      extras: [
        { tr: 'Peynir', en: 'Cheese' },
        { tr: 'Mantar', en: 'Mushroom' },
        { tr: 'Yumurta', en: 'Egg' },
        { tr: 'Acı Biber', en: 'Hot Pepper' },
      ],
    },
    {
      id: 158,
      name: { tr: 'Fındık Lahmacun (6 Adet)', en: 'Mini Lahmacun (6 Pcs)' },
      description: { tr: 'Mini boy lahmacun, kıymalı, baharatlı', en: 'Mini lahmacun with minced meat and spices' },
      price: 415,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 159,
      name: { tr: 'Peynirli Fındık (6 Adet)', en: 'Cheesy Mini Pita (6 Pcs)' },
      description: { tr: 'Mini boy peynirli pide', en: 'Mini cheese pita' },
      price: 415,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
      isPopular: true,
    },
  ],
  'fit-menuler': [
    {
      id: 42,
      name: { tr: 'Diyet Et Menü', en: 'Diet Beef Menu' },
      description: { tr: 'Izgara dana eti, buğulama sebzeler, pirinçsiz', en: 'Grilled beef, steamed vegetables, no rice' },
      price: 1100,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isHealthy: true,
    },
    {
      id: 43,
      name: { tr: 'Diyet Tavuk Menü', en: 'Diet Chicken Menu' },
      description: { tr: 'Izgara tavuk göğsü, buğulama sebzeler, pirinçsiz', en: 'Grilled chicken breast, steamed vegetables, no rice' },
      price: 875,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isHealthy: true,
      isPopular: true,
    },
    {
      id: 40,
      name: { tr: 'Et Salata', en: 'Beef Salad' },
      description: { tr: 'Izgara dana et, mevsim yeşillikleri, özel sos', en: 'Grilled beef, seasonal greens, special dressing' },
      price: 895,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isHealthy: true,
    },
    {
      id: 41,
      name: { tr: 'Tavuklu Salata', en: 'Chicken Salad' },
      description: { tr: 'Izgara tavuk göğsü, taze yeşillikler, limonlu sos', en: 'Grilled chicken breast, fresh greens, lemon dressing' },
      price: 835,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isHealthy: true,
      isPopular: true,
    },
    {
      id: 39,
      name: { tr: 'Hellimli Salata', en: 'Halloumi Salad' },
      description: { tr: 'Izgara hellim peyniri, taze yeşillikler, cherry domates', en: 'Grilled halloumi cheese, fresh greens, cherry tomatoes' },
      price: 650,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
      isHealthy: true,
      isPopular: true,
    },
  ],
  tatlilar: [
    {
      id: 43,
      name: { tr: 'Künefe', en: 'Künefe' },
      description: { tr: 'Kadayıf, peynir, şerbet', en: 'Shredded phyllo, cheese, syrup' },
      price: 435,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy'],
      isPopular: true,
    },
    {
      id: 48,
      name: { tr: 'Katmer', en: 'Katmer' },
      description: { tr: 'Antep fıstıklı katmer, kaymak', en: 'Pistachio katmer with clotted cream' },
      price: 390,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten', 'dairy', 'nuts'],
      isPopular: true,
    },
    {
      id: 45,
      name: { tr: 'Sütlaç', en: 'Rice Pudding' },
      description: { tr: 'Fırında sütlaç, tarçın', en: 'Baked rice pudding, cinnamon' },
      price: 190,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
    },
    {
      id: 46,
      name: { tr: 'Kazandibi', en: 'Kazandibi' },
      description: { tr: 'Karamelimsi muhallebi', en: 'Caramelized milk pudding' },
      price: 190,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
    },
    {
      id: 44,
      name: { tr: 'Baklava', en: 'Baklava' },
      description: { tr: 'Antep fıstıklı baklava (4 dilim)', en: 'Pistachio baklava (4 slices)' },
      price: 110,
      image: '/images/menu/baklava.webp',
      allergens: ['gluten', 'nuts'],
      isPopular: true,
    },
    {
      id: 47,
      name: { tr: 'Dondurma', en: 'Ice Cream' },
      description: { tr: 'Maraş dondurması (3 top)', en: 'Turkish ice cream (3 scoops)' },
      price: 65,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
    },
  ],
  icecekler: [
    {
      id: 170,
      name: { tr: 'Coca-Cola', en: 'Coca-Cola' },
      description: { tr: 'Coca-Cola (33cl)', en: 'Coca-Cola (33cl)' },
      price: 110,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isPopular: true,
      objectFit: 'contain',
    },
    {
      id: 171,
      name: { tr: 'Coca-Cola Zero Sugar', en: 'Coca-Cola Zero Sugar' },
      description: { tr: 'Şekersiz Cola (33cl)', en: 'Sugar-free Cola (33cl)' },
      price: 110,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
    {
      id: 172,
      name: { tr: 'Cappy Meyve Suyu', en: 'Cappy Fruit Juice' },
      description: { tr: 'Çeşitli meyve suları', en: 'Various fruit juices' },
      price: 95,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
    {
      id: 50,
      name: { tr: 'Ayran', en: 'Ayran' },
      description: { tr: 'Ev yapımı yoğurt içeceği', en: 'Homemade yogurt drink' },
      price: 30,
      image: '/images/menu/placeholder.webp',
      allergens: ['dairy'],
      isPopular: true,
      objectFit: 'contain',
    },
    {
      id: 51,
      name: { tr: 'Şalgam', en: 'Şalgam (Turnip Juice)' },
      description: { tr: 'Acılı veya acısız şalgam suyu', en: 'Spicy or mild turnip juice' },
      price: 35,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
    {
      id: 160,
      name: { tr: 'Cam Şişe Büyük', en: 'Large Glass Bottle' },
      description: { tr: 'Cam şişe su (büyük)', en: 'Glass bottle water (large)' },
      price: 120,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
    {
      id: 173,
      name: { tr: 'Cam Şişe Küçük', en: 'Small Glass Bottle' },
      description: { tr: 'Cam şişe su (küçük)', en: 'Glass bottle water (small)' },
      price: 80,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
    {
      id: 161,
      name: { tr: 'Büyük Su', en: 'Large Water' },
      description: { tr: 'Pet şişe su (1.5L)', en: 'PET bottle water (1.5L)' },
      price: 95,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
    {
      id: 162,
      name: { tr: 'Küçük Su', en: 'Small Water' },
      description: { tr: 'Pet şişe su (0.5L)', en: 'PET bottle water (0.5L)' },
      price: 50,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
    {
      id: 163,
      name: { tr: 'Soda', en: 'Soda' },
      description: { tr: 'Sade veya meyveli soda', en: 'Plain or flavored soda' },
      price: 110,
      image: '/images/menu/placeholder.webp',
      allergens: [],
      objectFit: 'contain',
    },
  ],
  'alkollu-icecekler': [
    // BİRALAR
    {
      id: 54,
      name: { tr: 'Efes', en: 'Efes' },
      description: { tr: 'Efes Pilsen (50cl)', en: 'Efes Pilsen (50cl)' },
      price: 250,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
      isPopular: true,
    },
    {
      id: 200,
      name: { tr: "Beck's", en: "Beck's" },
      description: { tr: "Beck's Bira (50cl)", en: "Beck's Beer (50cl)" },
      price: 280,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
    },
    {
      id: 201,
      name: { tr: 'Miller', en: 'Miller' },
      description: { tr: 'Miller Bira (50cl)', en: 'Miller Beer (50cl)' },
      price: 280,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
    },
    {
      id: 202,
      name: { tr: 'Bomonti', en: 'Bomonti' },
      description: { tr: 'Bomonti Bira (50cl)', en: 'Bomonti Beer (50cl)' },
      price: 260,
      image: '/images/menu/placeholder.webp',
      allergens: ['gluten'],
    },
    // RAKILAR - Yeni Rakı
    {
      id: 55,
      name: { tr: 'Yeni Rakı', en: 'Yeni Rakı' },
      description: { tr: '20cl / 35cl / 50cl / 70cl', en: '20cl / 35cl / 50cl / 70cl' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isPopular: true,
    },
    {
      id: 203,
      name: { tr: 'Yeni Rakı Yeni Seri', en: 'Yeni Rakı New Series' },
      description: { tr: '20cl / 35cl / 50cl / 70cl', en: '20cl / 35cl / 50cl / 70cl' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 204,
      name: { tr: 'Yeni Rakı Uzun Demleme', en: 'Yeni Rakı Long Aged' },
      description: { tr: '35cl / 70cl', en: '35cl / 70cl' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 205,
      name: { tr: 'Beylerbeyi Göbek', en: 'Beylerbeyi Göbek' },
      description: { tr: '20cl / 35cl / 50cl / 70cl', en: '20cl / 35cl / 50cl / 70cl' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/placeholder.webp',
      allergens: [],
    },
    {
      id: 206,
      name: { tr: 'Tekirdağ Altın Serisi', en: 'Tekirdağ Gold Series' },
      description: { tr: '20cl / 35cl / 50cl / 70cl', en: '20cl / 35cl / 50cl / 70cl' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/placeholder.webp',
      allergens: [],
      isPopular: true,
    },
    // ŞARAPLAR
    {
      id: 207,
      name: { tr: 'Cieolo Merlot', en: 'Cieolo Merlot' },
      description: { tr: 'Kırmızı Şarap', en: 'Red Wine' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/placeholder.webp',
      allergens: ['sulphites'],
    },
    {
      id: 208,
      name: { tr: 'Cieolo Chardonnay', en: 'Cieolo Chardonnay' },
      description: { tr: 'Beyaz Şarap', en: 'White Wine' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/placeholder.webp',
      allergens: ['sulphites'],
    },
    // VİSKİLER
    {
      id: 209,
      name: { tr: 'Red Label', en: 'Red Label' },
      description: { tr: 'Johnnie Walker Red Label', en: 'Johnnie Walker Red Label' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/black-label.webp',
      allergens: [],
    },
    {
      id: 210,
      name: { tr: 'Black Label', en: 'Black Label' },
      description: { tr: 'Johnnie Walker Black Label', en: 'Johnnie Walker Black Label' },
      price: 0,
      priceText: { tr: 'Fiyat için sorunuz', en: 'Ask for price' },
      image: '/images/menu/black-label.webp',
      allergens: [],
      isPopular: true,
    },
  ],
};

export const restaurantInfo = {
  name: 'GOMŞU RESTORAN',
  address: 'Atatürk Cad. No:5 Yenişehir / Lefkoşa',
  phone: '+90 392 228 05 86',
  whatsapp: '905338774243',
  hours: {
    open: '11:00',
    close: '00:00',
    days: { tr: 'Her Gün', en: 'Every Day' },
  },
  social: {
    instagram: 'https://www.instagram.com/gomsurestorant?igsh=MWRiZXk1dW9qZmI0OQ==',
    facebook: 'https://www.facebook.com/share/19UmnFdHTv/',
  },
  onlineOrderUrl: 'https://siparis.gomsurestoran.com/',
  backgroundImage: 'https://customer-assets.emergentagent.com/job_easy-menuscan/artifacts/2ws6hnk6_WhatsApp%20Image%202025-12-26%20at%2017.25.34%20%281%29.jpeg',
};
